"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisurePhotoDetailModalRequestSchema = exports.DomesticPhotoDetailModalRequestSchema = void 0;
var zod_1 = require("zod");
/**
 * filterType이 ROOM_TYPE일 경우 roomTypeIds 필수, 나머지는 roomTypeIds [] 로 넘겨주면 된다.
 * reviewId는 url의 resource로 들어간다.
 * */
exports.DomesticPhotoDetailModalRequestSchema = zod_1.z.object({
    resources: zod_1.z.object({ reviewId: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]) }),
    query: zod_1.z.union([
        zod_1.z.object({
            propertyId: zod_1.z.number(),
            roomTypeIds: zod_1.z.array(zod_1.z.number()),
            usePagination: zod_1.z.boolean(),
            photoId: zod_1.z.number(),
        }),
        zod_1.z.object({
            propertyId: zod_1.z.number(),
            roomTypeIds: zod_1.z.array(zod_1.z.number()),
            usePagination: zod_1.z.boolean(),
            photoIndex: zod_1.z.number(),
        }),
    ]),
});
exports.LeisurePhotoDetailModalRequestSchema = zod_1.z.object({
    resources: zod_1.z.object({ reviewId: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]) }),
    query: zod_1.z.union([
        zod_1.z.object({
            productGroupId: zod_1.z.number(),
            usePagination: zod_1.z.boolean(),
            photoId: zod_1.z.number(),
        }),
        zod_1.z.object({
            productGroupId: zod_1.z.number(),
            usePagination: zod_1.z.boolean(),
            photoIndex: zod_1.z.number(),
        }),
    ]),
});
